import axios from 'axios';

const instance = axios.create({
	baseURL: `${process.env.REACT_APP_AXIOS_DEVELOPMENT_BASE_URL}/api`,
	headers: {
		'Content-Type': 'application/json',
		'request-source': 'Admin-App',
	},
});

export const login = async (username, password) => instance.post('/auth/login', {
	username,
	password,
});

export const loginWithGoogle = async (idToken) => instance.post('/auth/login/google', {
	idToken,
	source: 'Admin-App',
});

export const updatePassword = async (userId, oldPassword, newPassword, token) => instance.patch('/auth/updatePassword', {
	userId,
	oldPassword,
	newPassword,
}, {
	headers: {
		Authorization: `Bearer ${token}`,
	},

});

export const resetPassword = async (userId, newPassword, token) => instance.patch('/auth/resetPassword', {
	userId,
	newPassword,
}, {
	headers: {
		Authorization: `Bearer ${token}`,
	},
});

export const resetForgottenPassword = async (token, newPassword) => instance.post('/auth/resetForgottenPassword', {
  resetToken: token,
  newPassword,
});

export const forgetPassword = async (email) => instance.post('/auth/forgetPassword', { email });
